import Layout from '../../internal/Layout.vue'
import SolutionsPage from './solutions.vue'

const SolutionRoutes = {
  component: Layout,
  children: [
    {
      name: 'solutions',
      path: '/',
      component: SolutionsPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
      },
    },
  ],
}

export default SolutionRoutes
